<template>
  <unicom-linha style="margin-bottom: 24px;">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Outros Serviços</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <!-- <unicom-coluna sm="8">
      <unicom-linha
        v-for="n in numeroDeServicos"
        :key="n"
        class="pack-de-forms"
      >
        <unicom-coluna sm="6" :class="espacamentoMobile" v-show="clickSwitch">
          <unicom-campo-texto
            ladoIcone="direito"
            clickIcone
            colorPlaceholder="#9E9E9E"
            placeholder="Tipos de procedimentos"
            v-model="payload.procedimento"
          />
        </unicom-coluna>

        <unicom-coluna sm="6" :class="espacamentoMobile">
          <single-select
            v-model="payload.tipoServicoPublico"
            :propsSingleSelect="{
              placeholder: 'Público',
              options: listaPublicoAlvo,
              'track-by': 'id',
              label: 'tipoServicoPublico'
            }"
            v-show="clickSwitch"
          />
        </unicom-coluna>
      </unicom-linha>
    </unicom-coluna> -->

    <!-- <unicom-coluna sm="1" :class="espacamentoMobile" v-show="clickSwitch">
      <div class="adicionar-campo" @click="adicionarPack">+</div>
    </unicom-coluna> -->

    <unicom-coluna sm="5" :class="espacamentoMobile" v-show="clickSwitch">
      <unicom-campo-texto
        ladoIcone="direito"
        :maxCaracteres="1500"
        clickIcone
        colorPlaceholder="#9E9E9E"
        placeholder="Outros Serviços"
        v-model="payload.especialidadesOferecidas"
      />
    </unicom-coluna>

    <unicom-coluna sm="4" :class="espacamentoMobile">
      <single-select
        @input="atualizarServicoPublico"
        :propsSingleSelect="{
          placeholder: 'Público',
          options: listaPublicoAlvo,
          'track-by': 'id',
          label: 'tipoServicoPublico'
        }"
        :value="payload.tipoServicoPublico"
        v-show="clickSwitch"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import SingleSelect from "@/views/RecursosPropriosQuestionarios/shared/Singleselect.vue";

import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    SingleSelect
  },
  data() {
    return {
      payload: {
        tipoServico: "Outros",
        especialidadesOferecidas: "",
        tipoServicoPublico: []
      }
      // numeroDeServicos: 1
    };
  },
  methods: {
    // adicionarPack() {
    //   return this.numeroDeServicos++;
    // },
  },
  watch: {
    "payload.tipoServicoPublico": `emitir`,
    "payload.especialidadesOferecidas": `emitir`,
    dadosServidor(newVal) {
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (
            servico.tipoServico.tipoServico === this.payload.tipoServico &&
            (servico.tipoServicoPublico || servico.especialidadesOferecidas)
          ) {
            this.clickSwitch = true;
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.preencheCampo(
              "especialidades oferecidas",
              servico.especialidadesOferecidas
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.adicionar-campo {
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  background: #00995d;
  text-align: center;
  font-size: 2rem;
  color: #fff;
  border-radius: 50%;
}
.pack-de-forms {
  margin-bottom: 1rem;
}
</style>
